<template>
  <v-toolbar app color="white elevation-1">
    <v-toolbar-side-icon v-if="showLogoutButton" @click="toggleDrawer" />
    <v-toolbar-title>
      <span>{{ title }}</span>
    </v-toolbar-title>

    <v-spacer />

    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn v-if="showLogoutButton" flat icon color="primary" v-on="on">
          <v-icon>account_circle</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-tile style="background: lightblue;">
          <v-list-tile-title style="font-weight: bold;">XProperty V.{{appVersion}}</v-list-tile-title>
        </v-list-tile>
        <v-divider/>
        <v-list-tile router to="/Configuration" @click="hideDrawer">
          <v-list-tile-title>Configuration</v-list-tile-title>
        </v-list-tile>
        <v-list-tile router to="/register" @click="hideDrawer">
          <v-list-tile-title>Register new account</v-list-tile-title>
        </v-list-tile>
        <v-divider/>
        <v-list-tile @click="logOut()">
          <v-list-tile-title>Logout</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-toolbar>
</template>
<script>
import {version} from '../../package'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'ContextMenu',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      personal: [{ text: 'User Info', route: '/UserInfo' }],
    }
  },
  computed: {
    ...mapGetters({
      drawer: 'User/getDrawer',
      showLogoutButton: 'User/getIsAuthenticated',
    }),
    appVersion() { return version }
  },
  mounted() {
    const isDesktop = window.innerWidth >= 1024
    this.displayDrawer(isDesktop)
  },
  methods: {
    ...mapActions({
      logOut: 'User/loggingOut',
      toggleDrawer: 'User/toggleDrawer',
    }),
    ...mapMutations({
      setDrawer: 'User/setDrawer',
    }),
    displayDrawer(show) {
      if (this.showLogoutButton) {
        this.setDrawer(show)
      }
    },
    hideDrawer() {
        this.setDrawer(false)
    },
  },
}
</script>
